import { camelCase, snakeCase } from 'changecase-objects';
import { URI } from '@deseretbook/utils';

var _typeof = 'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator ? function (e) {
  return typeof e;
} : function (e) {
  return e && 'function' == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? 'symbol' : typeof e;
},
    classCallCheck = function classCallCheck(e, t) {
  if (!(e instanceof t)) throw new TypeError('Cannot call a class as a function');
},
    _extends = Object.assign || function (e) {
  for (var t, n = 1; n < arguments.length; n++) {
    for (var s in t = arguments[n], t) {
      Object.prototype.hasOwnProperty.call(t, s) && (e[s] = t[s]);
    }
  }

  return e;
},
    inherits = function inherits(e, t) {
  if ('function' != typeof t && null !== t) throw new TypeError('Super expression must either be null or a function, not ' + typeof t);
  e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      enumerable: !1,
      writable: !0,
      configurable: !0
    }
  }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
},
    objectWithoutProperties = function objectWithoutProperties(e, t) {
  var n = {};

  for (var s in e) {
    0 <= t.indexOf(s) || Object.prototype.hasOwnProperty.call(e, s) && (n[s] = e[s]);
  }

  return n;
},
    possibleConstructorReturn = function possibleConstructorReturn(e, t) {
  if (!e) throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called');
  return t && ('object' == typeof t || 'function' == typeof t) ? t : e;
},
    BookshelfSdkError = function (e) {
  function t(e) {
    classCallCheck(this, t);
    var n = possibleConstructorReturn(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, e));
    return n.message = e, n.name = 'BookshelfSdkError', n;
  }

  return inherits(t, e), t;
}(Error),
    PropertyRequiredError = function (e) {
  function t(e) {
    classCallCheck(this, t);
    var n = possibleConstructorReturn(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, e));
    return n.message = 'Missing Required Property: ' + e, n.name = 'PropertyRequiredError', n;
  }

  return inherits(t, e), t;
}(BookshelfSdkError),
    TokenError = function (e) {
  function t(e) {
    classCallCheck(this, t);
    var n = possibleConstructorReturn(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, e.message));
    return n.code = e.code, n.name = 'TokenError', n;
  }

  return inherits(t, e), t;
}(BookshelfSdkError);

function buildPaginationResponse(e) {
  var t = Math.floor,
      n = t(e.from / e.size),
      s = t(e.total / e.size);
  return {
    page: n,
    firstPage: 0,
    lastPage: s,
    perPage: e.size,
    total: e.total,
    hasNextPage: n < s,
    hasPreviousPage: n > 0
  };
}

function formatImportData() {
  var e = 0 < arguments.length && arguments[0] !== void 0 ? arguments[0] : {};
  return camelCase(e);
}

function formatExportData() {
  var e = 0 < arguments.length && arguments[0] !== void 0 ? arguments[0] : {};
  return snakeCase(e, {
    exclude: ['filters[book_id]']
  });
}

function removeFalseyKeys(e) {
  var t = Object.assign({}, e);
  return Object.keys(t).forEach(function (e) {
    t[e] || delete t[e];
  }), t;
}

function checkErrors(e) {
  if (!e.ok) throw new BookshelfSdkError(e.statusText);
  return e.text().then(function (e) {
    var t;

    try {
      t = JSON.parse(e);
    } catch (e) {
      t = null;
    }

    if (t && !t.success && t.error) if ('invalid_token' === t.error.code) throw new TokenError(t.error);else throw new BookshelfSdkError(t.error.message || 'Unable to process request');
    return t ? formatImportData(t) : e;
  });
}

function post(e) {
  var t = 1 < arguments.length && arguments[1] !== void 0 ? arguments[1] : {},
      n = 2 < arguments.length && arguments[2] !== void 0 ? arguments[2] : {},
      s = _extends({
    t: n.token,
    language: n.language,
    device_id: n.deviceId
  }, t);

  return fetch('' + n.baseUrl + e, {
    method: 'POST',
    headers: _extends({
      "Content-Type": 'application/json'
    }, n.headers),
    body: JSON.stringify(formatExportData(s))
  }).then(checkErrors);
}

function get$1(e) {
  var t = 1 < arguments.length && arguments[1] !== void 0 ? arguments[1] : {},
      n = 2 < arguments.length && arguments[2] !== void 0 ? arguments[2] : {},
      s = _extends({
    t: n.token,
    language: n.language,
    device_id: n.deviceId
  }, t),
      i = URI('' + n.baseUrl + e);

  i.search(formatExportData(s));

  var o = _extends({}, {
    "Content-Type": 'application/json'
  }, n.headers);

  return fetch(i, {
    method: 'GET',
    headers: removeFalseyKeys(o)
  }).then(checkErrors);
}

function del(e) {
  var t = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : {},
      n = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : {},
      s = _extends({
    t: n.token,
    language: n.language,
    device_id: n.deviceId
  }, t),
      i = URI('' + n.baseUrl + e);

  return i.search(formatExportData(s)), fetch(i, {
    method: 'DELETE',
    headers: _extends({
      "Content-Type": 'application/json'
    }, n.headers)
  }).then(checkErrors);
}

function getChannel(e) {
  var t = 1 < arguments.length && arguments[1] !== void 0 ? arguments[1] : {},
      n = e.id,
      s = objectWithoutProperties(e, ['id']);
  if (!n) throw new PropertyRequiredError('id');
  if (!t.token) throw new PropertyRequiredError('token');
  return get$1('/channels/' + n, s, t).then(function (e) {
    return e.channel;
  });
}

function getChannelContent(e) {
  var t = 1 < arguments.length && arguments[1] !== void 0 ? arguments[1] : {},
      n = e.id,
      s = e.page,
      i = s === void 0 ? 0 : s,
      o = e.perPage,
      a = o === void 0 ? 20 : o,
      d = objectWithoutProperties(e, ['id', 'page', 'perPage']);
  if (!n) throw new PropertyRequiredError('id');
  if (!t.token) throw new PropertyRequiredError('token');
  return get$1('/channels/' + n + '/content', _extends({
    page: i + 1,
    perPage: a
  }, d), t).then(function (e) {
    return e.content;
  });
}

function getChannels() {
  var e = 0 < arguments.length && arguments[0] !== void 0 ? arguments[0] : {},
      t = 1 < arguments.length && arguments[1] !== void 0 ? arguments[1] : {};
  if (!t.token) throw new PropertyRequiredError('token');
  return get$1('/channels', e, t).then(function (e) {
    return e.channel;
  });
}

function addSample(e) {
  var t = 1 < arguments.length && arguments[1] !== void 0 ? arguments[1] : {},
      n = e.id,
      s = e.sku,
      i = objectWithoutProperties(e, ['id', 'sku']);
  if (!n) throw new PropertyRequiredError('id');
  if (!s) throw new PropertyRequiredError('sku');
  if (!t.token) throw new PropertyRequiredError('token');
  return post('/media/' + n + '/' + s + '/add_sample', i, t).then(function (e) {
    return e.media;
  });
}

var CREATE_SYNC_CODE = 0,
    UPDATE_SYNC_CODE = 1,
    DELETE_SYNC_CODE = 2;

function createAnnotation() {
  var e = 0 < arguments.length && arguments[0] !== void 0 ? arguments[0] : {},
      t = 1 < arguments.length && arguments[1] !== void 0 ? arguments[1] : {},
      n = e.id,
      s = e.bookId,
      i = e.documentId,
      o = e.created,
      a = e.changed,
      d = e.startBlr,
      r = e.endBlr,
      l = e.bookmark,
      h = e.highlight,
      c = e.note,
      k = e.tagIds,
      g = e.link,
      u = objectWithoutProperties(e, ['id', 'bookId', 'documentId', 'created', 'changed', 'startBlr', 'endBlr', 'bookmark', 'highlight', 'note', 'tagIds', 'link']);
  if (!t.deviceId) throw new PropertyRequiredError('deviceId');
  if (!t.token) throw new PropertyRequiredError('token');
  if (!d) throw new PropertyRequiredError('startBlr');
  if (!s) throw new PropertyRequiredError('bookId');
  if (!o) throw new PropertyRequiredError('created');
  if (!a) throw new PropertyRequiredError('changed');
  if (!n) throw new PropertyRequiredError('id');
  var p = {
    annotations: [_extends({
      syncCode: CREATE_SYNC_CODE,
      id: n,
      bookId: s,
      documentId: i,
      created: o,
      changed: a,
      startBlr: d,
      endBlr: r,
      bookmark: l,
      highlight: h,
      note: c,
      tagIds: k,
      link: g
    }, u)]
  };
  return post('/sync', p, t).then(function (e) {
    return e.annotations;
  });
}

function getAllAnnotations(e) {
  var t = 1 < arguments.length && arguments[1] !== void 0 ? arguments[1] : {},
      n = e.lastSyncId,
      s = objectWithoutProperties(e, ['lastSyncId']);
  if (!n) throw new PropertyRequiredError('lastSyncId');
  if (!t.deviceId) throw new PropertyRequiredError('deviceId');
  if (!t.token) throw new PropertyRequiredError('token');
  return get$1('/sync', _extends({
    lastSyncId: n
  }, s), t);
}

function getProduct(e) {
  var t = 1 < arguments.length && arguments[1] !== void 0 ? arguments[1] : {},
      n = e.id,
      s = e.sku,
      i = objectWithoutProperties(e, ['id', 'sku']);
  if (!n) throw new PropertyRequiredError('id');
  if (!s) throw new PropertyRequiredError('sku');
  if (!t.token) throw new PropertyRequiredError('token');
  return get$1('/media/' + n + '/' + s, i, t).then(function (e) {
    return e.ebook || e.audiobook;
  });
}

function getAudiobook() {
  var e = 0 < arguments.length && arguments[0] !== void 0 ? arguments[0] : {},
      t = 1 < arguments.length && arguments[1] !== void 0 ? arguments[1] : {};
  return getProduct(e, t);
}

function getAudiobookManifest(e) {
  var t = 1 < arguments.length && arguments[1] !== void 0 ? arguments[1] : {},
      n = e.id,
      s = e.sku,
      i = objectWithoutProperties(e, ['id', 'sku']);
  if (!n) throw new PropertyRequiredError('id');
  if (!s) throw new PropertyRequiredError('sku');
  if (!t.token) throw new PropertyRequiredError('token');
  return get$1('/media/' + n + '/' + s + '/manifest', i, t).then(function (e) {
    return e.manifest;
  });
}

function getBookAnnotations(e) {
  var t = 1 < arguments.length && arguments[1] !== void 0 ? arguments[1] : {},
      n = e.bookId,
      s = e.lastSyncId,
      i = objectWithoutProperties(e, ['bookId', 'lastSyncId']);
  if (!n) throw new PropertyRequiredError('bookId');
  if (!s) throw new PropertyRequiredError('lastSyncId');
  if (!t.deviceId) throw new PropertyRequiredError('deviceId');
  if (!t.token) throw new PropertyRequiredError('token');
  return get$1('/sync', _extends({
    lastSyncId: s,
    "filters[book_id]": n
  }, i), t);
}

function getBookInfo(e) {
  var t = 1 < arguments.length && arguments[1] !== void 0 ? arguments[1] : {},
      n = e.bookId,
      s = objectWithoutProperties(e, ['bookId']);
  if (!n) throw new PropertyRequiredError('bookId');
  return get$1('/books/' + n + '/info', s, t).then(function (e) {
    return e.book;
  });
}

function getEbook() {
  var e = 0 < arguments.length && arguments[0] !== void 0 ? arguments[0] : {},
      t = 1 < arguments.length && arguments[1] !== void 0 ? arguments[1] : {};
  return getProduct(e, t);
}

function getEbookContent(e) {
  var t = 1 < arguments.length && arguments[1] !== void 0 ? arguments[1] : {},
      n = e.id,
      s = e.sku,
      i = e.href,
      o = objectWithoutProperties(e, ['id', 'sku', 'href']);
  if (!n) throw new PropertyRequiredError('id');
  if (!s) throw new PropertyRequiredError('sku');
  if (!i) throw new PropertyRequiredError('href');
  if (!t.token) throw new PropertyRequiredError('token');
  return get$1('/media/' + n + '/' + s + '/content/' + i, o, _extends({}, t, {
    headers: _extends({}, t.headers, {
      "Content-Type": ''
    })
  }));
}

function getEbookPackage(e) {
  var t = 1 < arguments.length && arguments[1] !== void 0 ? arguments[1] : {},
      n = e.id,
      s = e.sku,
      i = objectWithoutProperties(e, ['id', 'sku']);
  if (!n) throw new PropertyRequiredError('id');
  if (!s) throw new PropertyRequiredError('sku');
  if (!t.token) throw new PropertyRequiredError('token');
  return get$1('/media/' + n + '/' + s + '/package', i, t).then(function (e) {
    return e.opf.package;
  });
}

function formatNavPoint(e) {
  var t = 1 < arguments.length && arguments[1] !== void 0 ? arguments[1] : {},
      n = Array.isArray(e) ? e : [e];
  return n.map(function (e) {
    var n = {
      parent: t.id,
      id: e.id,
      order: +e.playOrder || 0,
      label: e.navLabel ? e.navLabel.text : '',
      src: e.content ? e.content.src.split('#')[0] : ''
    };
    return Array.isArray(e.navPoint) ? n.nested = formatNavPoint(e.navPoint, e) : 'object' === _typeof(e.navPoint) && (n.nested = formatNavPoint([e.navPoint], e)), n;
  }).sort(function (e, t) {
    return e.order - t.order;
  });
}

function getEbookToc(e) {
  var t = 1 < arguments.length && arguments[1] !== void 0 ? arguments[1] : {},
      n = e.id,
      s = e.sku,
      i = objectWithoutProperties(e, ['id', 'sku']);
  if (!n) throw new PropertyRequiredError('id');
  if (!s) throw new PropertyRequiredError('sku');
  if (!t.token) throw new PropertyRequiredError('token');
  return get$1('/media/' + n + '/' + s + '/toc', i, t).then(function (e) {
    if (!e.toc || !e.toc.ncx || !e.toc.ncx.navMap || !e.toc.ncx.navMap.navPoint) throw new Error('Unknown TOC format.');
    return formatNavPoint(e.toc.ncx.navMap.navPoint);
  });
}

function getLibrary() {
  var e = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : {},
      t = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : {},
      n = e.page,
      s = e.perPage,
      i = objectWithoutProperties(e, ['page', 'perPage']);
  if (!t.token) throw new PropertyRequiredError('token');
  var o = i;
  return (n || s) && (o.from = n * s, o.size = s), get$1('/media/library', o, t).then(function (e) {
    return {
      results: e.group.media,
      pagination: n || s ? buildPaginationResponse(e.group) : null
    };
  });
}

function getMedia(e) {
  var t = 1 < arguments.length && arguments[1] !== void 0 ? arguments[1] : {},
      n = e.id,
      s = objectWithoutProperties(e, ['id']);
  if (!n) throw new PropertyRequiredError('id');
  if (!t.token) throw new PropertyRequiredError('token');
  return get$1('/media/' + n, s, t).then(function (e) {
    return e.media;
  });
}

function getMediaGroups() {
  var e = 0 < arguments.length && arguments[0] !== void 0 ? arguments[0] : {},
      t = 1 < arguments.length && arguments[1] !== void 0 ? arguments[1] : {};
  if (!t.token) throw new PropertyRequiredError('token');
  return get$1('/media', e, t).then(function (e) {
    return e.group.groups;
  });
}

function removeMediaFromLibrary(e) {
  var t = 1 < arguments.length && arguments[1] !== void 0 ? arguments[1] : {},
      n = e.id,
      s = e.sku,
      i = objectWithoutProperties(e, ['id', 'sku']);
  if (!n) throw new PropertyRequiredError('id');
  if (!s) throw new PropertyRequiredError('sku');
  if (!t.token) throw new PropertyRequiredError('token');
  return del('/media/' + n + '/' + s, i, t);
}

function removeSample(e) {
  var t = 1 < arguments.length && arguments[1] !== void 0 ? arguments[1] : {},
      n = e.id,
      s = e.sku,
      i = objectWithoutProperties(e, ['id', 'sku']);
  if (!n) throw new PropertyRequiredError('id');
  if (!s) throw new PropertyRequiredError('sku');
  if (!t.token) throw new PropertyRequiredError('token');
  return post('/media/' + n + '/' + s, _extends({
    deleted: !0
  }, i), t);
}

function reportUsage(e) {
  var t = e.seconds,
      n = e.item,
      s = e.id,
      i = e.sku,
      o = 1 < arguments.length && arguments[1] !== void 0 ? arguments[1] : {};
  if (!t) throw new PropertyRequiredError('item');
  if (!n) throw new PropertyRequiredError('seconds');
  return post('/media/' + s + '/' + i, {
    last_position: {
      item: n,
      seconds: t
    }
  }, o);
}

function reportUsage$1(e) {
  var t = 1 < arguments.length && arguments[1] !== void 0 ? arguments[1] : {},
      n = e.id,
      s = e.sku,
      i = e.opened,
      o = i === void 0 ? 0 : i,
      a = e.duration,
      d = a === void 0 ? 0 : a,
      r = e.subscribed,
      l = objectWithoutProperties(e, ['id', 'sku', 'opened', 'duration', 'subscribed']);
  if (!n) throw new PropertyRequiredError('id');
  if (!s) throw new PropertyRequiredError('sku');
  if (!t.token) throw new PropertyRequiredError('token');
  return post('/media/' + n + '/' + s + '/usage', {
    usage: _extends({
      opened: o,
      duration: d,
      subscribed: r !== void 0 && r
    }, l)
  }, t);
}

function saveAnnotation() {
  var e = 0 < arguments.length && arguments[0] !== void 0 ? arguments[0] : {},
      t = 1 < arguments.length && arguments[1] !== void 0 ? arguments[1] : {},
      n = e.id,
      s = e.bookId,
      i = e.documentId,
      o = e.created,
      a = e.changed,
      d = e.deleted,
      r = e.startBlr,
      l = e.endBlr,
      h = e.bookmark,
      c = e.highlight,
      k = e.note,
      g = e.link,
      u = e.tagIds,
      p = e.tags,
      m = objectWithoutProperties(e, ['id', 'bookId', 'documentId', 'created', 'changed', 'deleted', 'startBlr', 'endBlr', 'bookmark', 'highlight', 'note', 'link', 'tagIds', 'tags']);
  if (!t.deviceId) throw new PropertyRequiredError('deviceId');
  if (!t.token) throw new PropertyRequiredError('token');
  if (!n) throw new PropertyRequiredError('id');
  if (!s) throw new PropertyRequiredError('bookId');
  if (!i) throw new PropertyRequiredError('documentId');
  if (!r) throw new PropertyRequiredError('startBlr');
  if (!o) throw new PropertyRequiredError('created');

  if (h) {
    if (!h.name) throw new PropertyRequiredError('bookmark.name');
    h.id || (h.id = n);
  }

  if (c) {
    if (!c.style) throw new PropertyRequiredError('highlight.style');
    if (!c.color) throw new PropertyRequiredError('highlight.color');
    if (!c.content) throw new PropertyRequiredError('highlight.content');
  }

  if (k) {
    if (!k.title && !k.text) throw new PropertyRequiredError('note.title or note.text');
    k.id || (k.id = n);
  }

  if (g && !g.toBlr) throw new PropertyRequiredError('link.toBlr');
  var I = CREATE_SYNC_CODE;
  d ? I = DELETE_SYNC_CODE : a && (I = UPDATE_SYNC_CODE);

  var y = _extends({}, m, {
    syncCode: I,
    id: n,
    bookId: s,
    documentId: i,
    bookmark: h,
    highlight: c,
    note: k,
    link: g,
    created: o,
    changed: d || a || o,
    startBlr: r,
    endBlr: l,
    tagIds: u
  });

  return post('/sync', {
    annotations: [y],
    "filters[book_id]": s
  }, t).then(function (e) {
    return e.annotations.push(y), e.updatedAnnotation = y, e;
  });
}

function saveTag() {
  var e = 0 < arguments.length && arguments[0] !== void 0 ? arguments[0] : {},
      t = 1 < arguments.length && arguments[1] !== void 0 ? arguments[1] : {},
      n = e.id,
      s = e.created,
      i = e.changed,
      o = e.deleted,
      a = e.color,
      d = e.name,
      r = objectWithoutProperties(e, ['id', 'created', 'changed', 'deleted', 'color', 'name']);
  if (!t.deviceId) throw new PropertyRequiredError('deviceId');
  if (!t.token) throw new PropertyRequiredError('token');
  if (!n) throw new PropertyRequiredError('id');
  if (!s) throw new PropertyRequiredError('created');
  if (!d) throw new PropertyRequiredError('name');
  if (!a) throw new PropertyRequiredError('color');
  var l = CREATE_SYNC_CODE;
  o ? l = DELETE_SYNC_CODE : i && (l = UPDATE_SYNC_CODE);

  var h = _extends({
    syncCode: l,
    id: n,
    created: s,
    changed: o || i || s,
    color: a,
    name: d
  }, r);

  return post('/sync', {
    tags: [h]
  }, t).then(function (e) {
    return e.tags;
  });
}

function updateUserFavorite(e) {
  var t = 1 < arguments.length && arguments[1] !== void 0 ? arguments[1] : {},
      n = e.id,
      s = e.sku,
      i = e.favorite,
      o = objectWithoutProperties(e, ['id', 'sku', 'favorite']);
  if (!n) throw new PropertyRequiredError('id');
  if (!s) throw new PropertyRequiredError('sku');
  if (!t.token) throw new PropertyRequiredError('token');
  return post('/media/' + n + '/' + s, _extends({
    favorite: !(i !== void 0) || i
  }, o), t);
}

function updateUserLastPosition(e) {
  var t = 1 < arguments.length && arguments[1] !== void 0 ? arguments[1] : {},
      n = e.id,
      s = e.sku,
      i = e.lastPosition,
      o = objectWithoutProperties(e, ['id', 'sku', 'lastPosition']);
  if (!n) throw new PropertyRequiredError('id');
  if (!s) throw new PropertyRequiredError('sku');
  if (!i) throw new PropertyRequiredError('lastPosition');
  if (!t.token) throw new PropertyRequiredError('token');
  return post('/media/' + n + '/' + s, _extends({
    last_position: i
  }, o), t);
}

function getProductRecommendations(e) {
  var t = 1 < arguments.length && arguments[1] !== void 0 ? arguments[1] : {},
      n = e.sku,
      s = e.mediaId,
      i = objectWithoutProperties(e, ['sku', 'mediaId']);
  if (!t.token) throw new PropertyRequiredError('token');
  if (!n) throw new PropertyRequiredError('sku');
  if (!s) throw new PropertyRequiredError('mediaId');
  return get$1('/media/' + s + '/' + n + '/recommendations', i, t).then(function (e) {
    return e.recommendations;
  });
}

function getMediaByAuthor(e) {
  var t = 1 < arguments.length && arguments[1] !== void 0 ? arguments[1] : {},
      n = e.authorId,
      s = e.contentSet,
      i = s === void 0 ? 'catalog' : s,
      o = e.includeSkus,
      a = o === void 0 ? [] : o,
      d = e.excludeSkus,
      r = d === void 0 ? [] : d,
      l = e.page,
      h = l === void 0 ? 0 : l,
      c = e.perPage,
      k = c === void 0 ? 20 : c,
      g = objectWithoutProperties(e, ['authorId', 'contentSet', 'includeSkus', 'excludeSkus', 'page', 'perPage']);
  if (!n) throw new PropertyRequiredError('authorId');
  if (!t.token) throw new PropertyRequiredError('token');
  return post('/ng_search/media', _extends({
    author_id: n,
    content_set: i,
    include_skus: a,
    exclude_skus: r,
    from: h * k,
    size: k
  }, g), t).then(function (e) {
    return {
      results: e.media,
      pagination: buildPaginationResponse(e)
    };
  });
}

function getMediaByTopic(e) {
  var t = 1 < arguments.length && arguments[1] !== void 0 ? arguments[1] : {},
      n = e.topicId,
      s = e.contentSet,
      i = s === void 0 ? 'catalog' : s,
      o = e.includeSkus,
      a = o === void 0 ? [] : o,
      d = e.excludeSkus,
      r = d === void 0 ? [] : d,
      l = e.page,
      h = l === void 0 ? 0 : l,
      c = e.perPage,
      k = c === void 0 ? 20 : c,
      g = objectWithoutProperties(e, ['topicId', 'contentSet', 'includeSkus', 'excludeSkus', 'page', 'perPage']);
  if (!n) throw new PropertyRequiredError('topicId');
  if (!t.token) throw new PropertyRequiredError('token');
  return post('/ng_search/media', _extends({
    topic_id: n,
    content_set: i,
    include_skus: a,
    exclude_skus: r,
    from: h * k,
    size: k
  }, g), t).then(function (e) {
    return {
      results: e.media,
      pagination: buildPaginationResponse(e)
    };
  });
}

function getSuggestions(e) {
  var t = 1 < arguments.length && arguments[1] !== void 0 ? arguments[1] : {},
      n = e.query,
      s = objectWithoutProperties(e, ['query']);
  if (!n) throw new PropertyRequiredError('query');
  if (!t.token) throw new PropertyRequiredError('token');
  return get$1('/ng_search/suggest', _extends({
    query: n
  }, s), t).then(function (e) {
    return {
      results: e.suggestions
    };
  });
}

function searchAuthors(e) {
  var t = 1 < arguments.length && arguments[1] !== void 0 ? arguments[1] : {},
      n = e.query,
      s = e.page,
      i = s === void 0 ? 0 : s,
      o = e.perPage,
      a = o === void 0 ? 20 : o,
      d = objectWithoutProperties(e, ['query', 'page', 'perPage']);
  if (!n) throw new PropertyRequiredError('query');
  if (!t.token) throw new PropertyRequiredError('token');
  return post('/ng_search/authors', _extends({
    query: n,
    from: i * a,
    size: a
  }, d), t).then(function (e) {
    return {
      results: e.authorMatches,
      pagination: buildPaginationResponse(e)
    };
  });
}

function searchEbookContents(e) {
  var t = 1 < arguments.length && arguments[1] !== void 0 ? arguments[1] : {},
      n = e.query,
      s = e.paragraphId,
      i = e.contentSet,
      o = i === void 0 ? 'catalog' : i,
      a = e.includeSkus,
      d = a === void 0 ? [] : a,
      r = e.excludeSkus,
      l = r === void 0 ? [] : r,
      h = e.page,
      c = h === void 0 ? 0 : h,
      k = e.perPage,
      g = k === void 0 ? 20 : k,
      u = objectWithoutProperties(e, ['query', 'paragraphId', 'contentSet', 'includeSkus', 'excludeSkus', 'page', 'perPage']);
  if (!n) throw new PropertyRequiredError('query');
  if (!t.token) throw new PropertyRequiredError('token');
  return post('/ng_search/media_contents', _extends({
    query: n,
    paragraphId: s,
    contentSet: o,
    includeSkus: d,
    excludeSkus: l,
    from: c * g,
    size: g
  }, u), t).then(function (e) {
    return {
      results: e.mediaContentMatches,
      pagination: buildPaginationResponse(e)
    };
  });
}

function searchEverything(e) {
  var t = 1 < arguments.length && arguments[1] !== void 0 ? arguments[1] : {},
      n = e.query,
      s = e.contentSet,
      i = s === void 0 ? 'catalog' : s,
      o = e.includeSkus,
      a = o === void 0 ? [] : o,
      d = e.excludeSkus,
      r = d === void 0 ? [] : d,
      l = e.groupBy,
      h = l === void 0 ? 'none' : l,
      c = e.page,
      k = c === void 0 ? 0 : c,
      g = e.perPage,
      u = g === void 0 ? 20 : g,
      p = objectWithoutProperties(e, ['query', 'contentSet', 'includeSkus', 'excludeSkus', 'groupBy', 'page', 'perPage']);
  if (!n) throw new PropertyRequiredError('query');
  if (!t.token) throw new PropertyRequiredError('token');
  return post('/ng_search', _extends({
    query: n,
    contentSet: i,
    includeSkus: a,
    excludeSkus: r,
    groupBy: h,
    from: k * u,
    size: u
  }, p), t).then(function (e) {
    return {
      authors: e.authorMatches,
      topics: e.topicMatches,
      media: e.mediaTitleMatches,
      ebookContents: e.mediaContentMatches
    };
  });
}

function searchMediaTitles(e) {
  var t = 1 < arguments.length && arguments[1] !== void 0 ? arguments[1] : {},
      n = e.query,
      s = e.contentSet,
      i = s === void 0 ? 'catalog' : s,
      o = e.includeSkus,
      a = o === void 0 ? [] : o,
      d = e.excludeSkus,
      r = d === void 0 ? [] : d,
      l = e.page,
      h = l === void 0 ? 0 : l,
      c = e.perPage,
      k = c === void 0 ? 20 : c,
      g = objectWithoutProperties(e, ['query', 'contentSet', 'includeSkus', 'excludeSkus', 'page', 'perPage']);
  if (!n) throw new PropertyRequiredError('query');
  if (!t.token) throw new PropertyRequiredError('token');
  return post('/ng_search/media_titles', _extends({
    query: n,
    contentSet: i,
    includeSkus: a,
    excludeSkus: r,
    from: h * k,
    size: k
  }, g), t).then(function (e) {
    return {
      results: e.mediaTitleMatches,
      pagination: buildPaginationResponse(e)
    };
  });
}

function searchTopics(e) {
  var t = 1 < arguments.length && arguments[1] !== void 0 ? arguments[1] : {},
      n = e.query,
      s = e.page,
      i = s === void 0 ? 0 : s,
      o = e.perPage,
      a = o === void 0 ? 20 : o,
      d = objectWithoutProperties(e, ['query', 'page', 'perPage']);
  if (!n) throw new PropertyRequiredError('query');
  if (!t.token) throw new PropertyRequiredError('token');
  return post('/ng_search/topics', _extends({
    query: n,
    from: i * a,
    size: a
  }, d), t).then(function (e) {
    return {
      results: e.topicMatches,
      pagination: buildPaginationResponse(e)
    };
  });
}

function getSubscriptionPlans() {
  var e = 0 < arguments.length && arguments[0] !== void 0 ? arguments[0] : {},
      t = 1 < arguments.length && arguments[1] !== void 0 ? arguments[1] : {};
  if (!t.token) throw new PropertyRequiredError('token');
  return get$1('/subscriptions', e, t).then(function (e) {
    return e.subscriptions;
  });
}

function login(e) {
  var t = 1 < arguments.length && arguments[1] !== void 0 ? arguments[1] : {},
      n = e.email,
      s = e.password,
      i = objectWithoutProperties(e, ['email', 'password']);
  if (!n) throw new PropertyRequiredError('email');
  if (!s) throw new PropertyRequiredError('password');
  return post('/login_account', _extends({
    email: n,
    password: s
  }, i), t);
}

function register(e) {
  var t = 1 < arguments.length && arguments[1] !== void 0 ? arguments[1] : {},
      n = e.firstName,
      s = e.lastName,
      i = e.email,
      o = e.password,
      a = objectWithoutProperties(e, ['firstName', 'lastName', 'email', 'password']);
  if (!i) throw new PropertyRequiredError('email');
  if (!o) throw new PropertyRequiredError('password');
  return post('/create_account', _extends({
    firstName: n,
    lastName: s,
    email: i,
    password: o
  }, a), t);
}

function addAudiobookToWishList(e) {
  var t = 1 < arguments.length && arguments[1] !== void 0 ? arguments[1] : {},
      n = e.wishListId,
      s = e.mediaId,
      i = objectWithoutProperties(e, ['wishListId', 'mediaId']);
  if (!t.token) throw new PropertyRequiredError('token');
  if (!n) throw new PropertyRequiredError('wishListId');
  if (!s) throw new PropertyRequiredError('mediaId');
  return post('/wish_lists/' + n + '/media/' + s + '/audiobook', _extends({}, i), t).then(function (e) {
    return e.success;
  });
}

function addEbookToWishList(e) {
  var t = 1 < arguments.length && arguments[1] !== void 0 ? arguments[1] : {},
      n = e.wishListId,
      s = e.mediaId,
      i = objectWithoutProperties(e, ['wishListId', 'mediaId']);
  if (!t.token) throw new PropertyRequiredError('token');
  if (!n) throw new PropertyRequiredError('wishListId');
  if (!s) throw new PropertyRequiredError('mediaId');
  return post('/wish_lists/' + n + '/media/' + s + '/ebook', _extends({}, i), t).then(function (e) {
    return e.success;
  });
}

function addWishListItemBySKU(e) {
  var t = 1 < arguments.length && arguments[1] !== void 0 ? arguments[1] : {},
      n = e.wishListId,
      s = e.sku,
      i = objectWithoutProperties(e, ['wishListId', 'sku']);
  if (!t.token) throw new PropertyRequiredError('token');
  if (!n) throw new PropertyRequiredError('wishListId');
  if (!s) throw new PropertyRequiredError('sku');
  return post('/wish_lists/' + n + '/media/' + s, _extends({}, i), t).then(function (e) {
    return e.success;
  });
}

function createWishList() {
  var e = 0 < arguments.length && arguments[0] !== void 0 ? arguments[0] : {},
      t = 1 < arguments.length && arguments[1] !== void 0 ? arguments[1] : {},
      n = e.isDefault,
      s = e.isPrivate,
      i = e.name,
      o = objectWithoutProperties(e, ['isDefault', 'isPrivate', 'name']);
  if (!t.token) throw new PropertyRequiredError('token');
  if (!i) throw new PropertyRequiredError('name');

  var a = _extends({
    wishList: {
      isDefault: n !== void 0 && n,
      isPrivate: !(s !== void 0) || s,
      name: i
    }
  }, o);

  return post('/wish_lists', a, t).then(function (e) {
    return e.wishList;
  });
}

function deleteWishList(e) {
  var t = 1 < arguments.length && arguments[1] !== void 0 ? arguments[1] : {},
      n = e.wishListId,
      s = objectWithoutProperties(e, ['wishListId']);
  if (!t.token) throw new PropertyRequiredError('token');
  if (!n) throw new PropertyRequiredError('wishListId');
  return del('/wish_lists/' + n, _extends({}, s), t).then(function (e) {
    return e.success;
  });
}

function getWishList(e) {
  var t = 1 < arguments.length && arguments[1] !== void 0 ? arguments[1] : {},
      n = e.wishListId,
      s = objectWithoutProperties(e, ['wishListId']);
  if (!t.token) throw new PropertyRequiredError('token');
  if (!n) throw new PropertyRequiredError('wishListId');
  return get$1('/wish_lists/' + n, _extends({}, s), t).then(function (e) {
    return e.wishList;
  });
}

function getWishListItems(e) {
  var t = 1 < arguments.length && arguments[1] !== void 0 ? arguments[1] : {},
      n = e.wishListId,
      s = objectWithoutProperties(e, ['wishListId']);
  if (!t.token) throw new PropertyRequiredError('token');
  if (!n) throw new PropertyRequiredError('wishListId');
  return get$1('/wish_lists/' + n + '/media', _extends({}, s), t).then(function (e) {
    return e.media;
  });
}

function getWishLists(e) {
  var t = 1 < arguments.length && arguments[1] !== void 0 ? arguments[1] : {},
      n = e.page,
      s = n === void 0 ? 0 : n,
      i = e.perPage,
      o = i === void 0 ? 25 : i,
      a = objectWithoutProperties(e, ['page', 'perPage']);
  if (!t.token) throw new PropertyRequiredError('token');
  return get$1('/wish_lists', _extends({
    page: s + 1,
    perPage: o
  }, a), t).then(function (e) {
    return e.wishLists;
  });
}

function removeAudiobookFromWishList() {
  var e = 0 < arguments.length && arguments[0] !== void 0 ? arguments[0] : {},
      t = 1 < arguments.length && arguments[1] !== void 0 ? arguments[1] : {},
      n = e.wishListId,
      s = e.mediaId,
      i = objectWithoutProperties(e, ['wishListId', 'mediaId']);
  if (!t.token) throw new PropertyRequiredError('token');
  if (!n) throw new PropertyRequiredError('wishListId');
  if (!s) throw new PropertyRequiredError('mediaId');
  return del('/wish_lists/' + n + '/media/' + s + '/audiobook', _extends({}, i), t).then(function (e) {
    return e.success;
  });
}

function removeEbookFromWishList() {
  var e = 0 < arguments.length && arguments[0] !== void 0 ? arguments[0] : {},
      t = 1 < arguments.length && arguments[1] !== void 0 ? arguments[1] : {},
      n = e.wishListId,
      s = e.mediaId,
      i = objectWithoutProperties(e, ['wishListId', 'mediaId']);
  if (!t.token) throw new PropertyRequiredError('token');
  if (!n) throw new PropertyRequiredError('wishListId');
  if (!s) throw new PropertyRequiredError('mediaId');
  return del('/wish_lists/' + n + '/media/' + s + '/ebook', _extends({}, i), t).then(function (e) {
    return e.success;
  });
}

function removeProductFromWishList(e) {
  var t = 1 < arguments.length && arguments[1] !== void 0 ? arguments[1] : {},
      n = e.wishListId,
      s = e.sku,
      i = objectWithoutProperties(e, ['wishListId', 'sku']);
  if (!t.token) throw new PropertyRequiredError('token');
  if (!n) throw new PropertyRequiredError('wishListId');
  if (!s) throw new PropertyRequiredError('sku');
  return del('/wish_lists/' + n + '/media/' + s, _extends({}, i), t).then(function (e) {
    return e.success;
  });
}

function updateWishList() {
  var e = 0 < arguments.length && arguments[0] !== void 0 ? arguments[0] : {},
      t = 1 < arguments.length && arguments[1] !== void 0 ? arguments[1] : {},
      n = e.wishListId,
      s = e.name,
      i = e.isDefault,
      o = e.isPrivate,
      a = objectWithoutProperties(e, ['wishListId', 'name', 'isDefault', 'isPrivate']);
  if (!t.token) throw new PropertyRequiredError('token');
  if (!n) throw new PropertyRequiredError('wishListId');

  var d = _extends({
    wish_list: {
      is_default: i,
      is_private: o,
      name: s
    }
  }, a);

  return post('/wish_lists/' + n, d, t).then(function (e) {
    return e.success;
  });
}

export { getChannel, getChannelContent, getChannels, addSample, createAnnotation as createBookmark, getAllAnnotations, getAudiobook, getAudiobookManifest, getBookAnnotations, getBookInfo, getEbook, getEbookContent, getEbookPackage, getEbookToc, getLibrary, getMedia, getMediaGroups, getProduct, removeMediaFromLibrary, removeSample, reportUsage as reportAudiobookPosition, reportUsage$1 as reportUsage, saveAnnotation, saveTag, updateUserFavorite, updateUserLastPosition, getProductRecommendations, getMediaByAuthor, getMediaByTopic, getSuggestions, searchAuthors, searchEbookContents, searchEverything, searchMediaTitles, searchTopics, getSubscriptionPlans, login, register, addAudiobookToWishList, addEbookToWishList, addWishListItemBySKU as addProductToWishList, createWishList, deleteWishList, getWishList, getWishListItems, getWishLists, removeAudiobookFromWishList, removeEbookFromWishList, removeProductFromWishList, updateWishList };